import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import NavigationPrompt from 'react-router-navigation-prompt';

import Alert from '../../../dialogs/Alert';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';
import PanelInfo from '../../../labels/PanelInfo';
import Fields from './Fields';
import Rules from './Rules';
import EditRules from './EditRules';


import { bindActionCreators } from 'redux';
import * as actionsprocess from '../../../../actions/api.manage.process.actions';
import * as actionsform from '../../../../actions/api.manage.form.actions';
import * as home from '../../../../actions/process.home.actions';
import * as security from '../../../../actions/session.actions';
import { get, getWithoutError } from '../../../../api/_basic';
import ManageFormApi from '../../../../api/ManageFormApi';

import { SaveIcon, ExpandAll, ColapseAll } from '../../../../images/icons/WrapSvg';

function toolbar(handle, show, pending, submmit) {
    const aux = [];
    if (show) {
        aux.push(
            <ExpandAll
                key="submmit-post-employee"
                className="hand"
                color="primary"
                onClick={(event) => handle(!show)}
            />,
        );
    } else {
        aux.push(
            <ColapseAll
                key="submmit-post-employee"
                className="hand"
                color="primary"
                onClick={(event) => handle(!show)}
            />,
        );
    }

    if (pending) {
        aux.push(
            <SaveIcon
                key="submit-form"
                onClick={() => submmit()}
                className={'c_bluish hand'}
            />,
        );
    } else {
        aux.push(<SaveIcon key="submit-form" className={'c_disabled'} />);
    }
    return aux;
}

function expandNodes(element, show) {
    if (element.hijos) {
        element.hide = show;
        element.hijos = element.hijos.map((e) => {
            return expandNodes(e, show);
        });
    }
    return element;
}

class Main extends React.Component {
    state = {
        form: this.props.form,
        rules: [],
        rule: undefined,
        error: undefined,
        errorType: undefined
    };

    constructor(props) {
        super(props);
        const {
            manage_process,
            manage_process_is_loading,
            manage_process_has_error,
            family,
        } = props;
        if (
            !family ||
            !manage_process ||
            !manage_process.families ||
            manage_process_is_loading ||
            manage_process_has_error.hasErrored
        ) {
            props.loadManageProcesses();
        }
        this.props.loadManageForm(this.props.process);

        const tools = [toolbar(this.handleExpand, false, false, this.handleSummit)];
        this.props.setTools(tools);
        this.load();
        this.props.loadBasicInfo();
    }

    load = () => {
        var p1 = new Promise((resolve, reject) => {
            resolve( get(process.env.REACT_APP_API_MASTER + '/entidad') );
            reject();
        });
        var p2 = new Promise((resolve, reject) => {
            resolve( getWithoutError(process.env.REACT_APP_API_MASTER + '/tiporegla') );
            reject();
        });
        var p3 = new Promise((resolve, reject) => {
            resolve ( get(process.env.REACT_APP_API_MASTER + '/catalogoregla'));
            reject();
        });
        var p4 = new Promise((resolve, reject) => {
            resolve( this.props.loadTemplateProcess(this.props.process));
            reject();
        });

        Promise.all([p1, p2, p3, p4]).then((values) => {

            const entities = values[0] ? values[0] : {};
            const tiporegla = values[1] ? values[1] : []; 
            const options = values[2] ? values[2] : [];
            const templates = values[3] ? values[3].sort((a, b) => a.nombre && b.nombre && a.nombre.toUpperCase() > b.nombre.toUpperCase() ? -1 : 1) : []; 

            this.setState({
                entities: entities
                    ? Object.keys(entities).map((i) => {
                          return entities[i];
                      })
                    : [],
                tiporegla: tiporegla,
                options: options,
                templates: templates
            });
        });
    }


    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        const { manage_form } = props;
        console.log(manage_form, state.manage_form);
        if (manage_form !== state.manage_form) {
            state.manage_form = manage_form;
            state.data = manage_form && manage_form.tabs ? manage_form.tabs : [];
            state.rules = manage_form && manage_form.rules ? manage_form.rules : [];
            return state;
        }
        return null;
    }

    handleExpand = (show) => {
        this.setState({ show: show });
        const tools = [
            toolbar(this.handleExpand, show, this.state.pending_changes, this.handleSummit),
        ];
        this.props.setTools(tools);
        if (this.state.data) {
            this.state.data.map((child) => expandNodes(child, show));
        }
    };

    handleModification = (data) => {
        const tools = [toolbar(this.handleExpand, this.state.show, true, this.handleSummit)];
        this.props.setTools(tools);
        this.setState({ data: data, pending_changes: true });
    };

    handleSummit = () => {
        const { pending_changes, data } = this.state;
        const { process, manage_form } = this.props;
        if (pending_changes) {
            this.props
                .updateFields(data, process, manage_form.form)
                .then((r) => {
                    if (r.error) {
                        this.setState({ error: r.error.message, errorType: r.error.type, confirm_save: false });
                    } else {
                        this.props.update(manage_form);
                        this.load();
                        const tools = [toolbar(this.handleExpand, this.state.show, false, this.handleSummit)];
                        this.props.setTools(tools);
                        this.setState({ pending_changes: false, edit_rule: !!this.state.rule, confirm_save: false });
                    }
                })
                .catch((error) => this.setState({ error: error.message }));
        }
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    openRule = (rule) => {
        const {pending_changes} = this.state;
        if(pending_changes) {
            this.setState({ 
                confirm_save: true, 
                rule: rule, 
                type: rule && rule.tipo ? rule.tipo.toString() : undefined,
                message: undefined, 
                selectedField: undefined, 
                selectedType: undefined, 
                selectedRule: undefined  
            });
        } else {
            this.setState({ 
                edit_rule: true, 
                rule: rule, 
                type: rule && rule.tipo ? rule.tipo.toString() : undefined, 
                message: undefined, 
                selectedField: undefined, 
                selectedType: undefined, 
                selectedRule: undefined 
            });
        }
    }

    handleDeleteRule = (rule) => {
        const {rules} = this.state;
        this.setState({ rules: rules.filter((f) => f.id.toString() !== rule.codigo.toString()) });
    }

    handleCloseRule = (rule) => {
        const {rules} = this.state;
        if(rule && rule.id) {
            ManageFormApi.updateRule(rule)
                        .then(() =>{
                            const index = rules.map((i) => i.id).indexOf(rule.id);
                            if(index >= 0 && rule.id) {
                                rules.splice(index, 1, rule);
                            } else {
                                rules.push(rule);
                            }
                            this.setState({ edit_rule: false, rules: rules, rule: undefined });
                        })
                        .catch((error) => this.setState({error: error.message, errorType: error.type}));

        } else if(rule) {
            ManageFormApi.postRule(rule)
                        .then((result) => {
                            rule.id = result.id;
                            rules.push(rule);
                            this.setState({ edit_rule: false, rules: rules, rule: undefined });
                        })
                        .catch((error) => this.setState({error: error.message, errorType: error.type}));
        }
        this.setState({ edit_rule: false, rule: undefined });
    };

    handleChange = (field, value) => {
        const {rule, type} = this.state;
        rule[field] = value;
        const aux = field === 'tipo' ? ( value ? value.toString() : undefined ) : type;
        this.setState({ type: aux, rule: rule });
    }

    handleAddCondition = (field) => {
        const { rule } = this.state;
        const valid =
            rule && rule.accion
                ? rule.accion.reduce((result, item) => {
                      if (item.parametros && item.parametros.campo && item.parametros.campo.codigo === field.codigo) {
                          result = false;
                      }
                      return result;
                  }, true)
                : false;
        if (valid && rule && rule.condicion) {
            rule.condicion.push({
                tipo: undefined,
                parametros: {campo: field}
            });
        }
        this.setState({ rule: rule });
    };

    handleAddAction = (field) => {
        const { rule } = this.state;
        const validActions =
            rule && rule.accion
                ? rule.accion.reduce((result, item) => {
                      if (item.parametros && item.parametros.campo && item.parametros.campo.codigo === field.codigo) {
                          result = false;
                      }
                      return result;
                  }, true)
                : false;
        const validConditions =
            rule && rule.condicion
                ? rule.condicion.reduce((result, item) => {
                      if (item.parametros && item.parametros.campo && item.parametros.campo.codigo === field.codigo){
                          result = false;
                      }
                      return result;
                  }, true)
                : false;
        if (validConditions && validActions && rule && rule.accion) {
            rule.accion.push({
                tipo: 1,
                parametros: {campo: field}
            });
        }
        this.setState({ rule: rule });
    };

    handleAddActionTransition = (accion) => {
        const { rule } = this.state;
        rule.accion.push(accion);
        this.setState({ rule: rule });
    }

    handleAddConditionTransition = (condicion) => {
        const { rule } = this.state;
        rule.condicion.push(condicion);
        this.setState({ rule: rule });
    }

    handleCancel = () => {
        this.setState({confirm_save: false, rule: undefined, type: undefined});
    }
 
    handleDeleteCondition = (e) => {
        const { rule } = this.state;
        rule.condicion.splice(e, 1);
        this.setState({ rule: rule });
    };

    handleDeleteAction = (e) => {
        const { rule } = this.state;
        rule.accion.splice(e, 1);
        this.setState({ rule: rule });
    };

    handleClose = () => {
        this.setState({ 
            error: undefined, 
            message: undefined, 
            selectedField: undefined, 
            selectedType: undefined, 
            selectedRule: undefined 
        });
    };

    handleSelectedField = (field, type) => {
        this._div.scrollTop = 0;
        this.setState({
            selectedField: field, 
            selectedType: type,
            message: this.props.intl.formatMessage({ id: 'checks_field_selection' })
        });
    }

    handleSelectedRule = (rule) => {
        this.setState({
            selectedRule: rule,
            message: this.props.intl.formatMessage({ id: 'checks_rule_selection' })
        });
    }

    render() {
        const {
            form,
            info,
            manage_process,
            manage_form_is_loading,
            manage_form_is_saving,
            manage_form_has_error,
        } = this.props;

        const { 
            entities, 
            options, 
            data, 
            rules, 
            rule, 
            pending_changes, 
            edit_rule, 
            tiporegla,
            manage_form,
            templates,
            error,
            errorType,
            confirm_save,
            type,
            selectedField,
            selectedType,
            selectedRule,
            message
        } = this.state;

        console.log('Main', rules);

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '62') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (manage_form_has_error.hasErrored) {
            return (
                <Error open message={manage_form_has_error.error} handleClose={this.handleBack} />
            );
        } else {
            const rulesAvailable = info.security.licencias.some((f) => f.id === 151 && f.activo);
            return (
                <div className="flex_full_column">
                    <NavigationPrompt
                        when={(crntLocation, nextLocation) =>
                            pending_changes &&
                            (!nextLocation || !nextLocation.pathname.includes(form))
                        }
                    >
                        {({ onConfirm, onCancel }) => (
                            <Alert
                                title="alert_dialog_discard_title"
                                text="alert_dialog_discard_message"
                                open={true}
                                onCancel={onCancel}
                                onConfirm={onConfirm}
                            />
                        )}
                    </NavigationPrompt>
                    {(manage_form_is_loading || manage_form_is_saving) && <Loading open opacity />}
                    <div className="flex_full_row height100">
                        <div
                            className={
                                'flex_40 overflow_y_scroll  ' +
                                (rulesAvailable ? ' showbar ' : '') +
                                (edit_rule ? 'bg_cloudy_blue_30 shadow_right_only' : '')
                            }
                            ref={(ref) => this._div = ref}
                        >
                            {!rulesAvailable &&
                                <PanelInfo id={'license_rules_available'} />
                            }
                            {(rulesAvailable && !edit_rule) && 
                                <Rules
                                    {...this.props}
                                    rules={rules}
                                    selectedField={selectedField}
                                    selectedType={selectedType}
                                    selectedRule={selectedRule}
                                    onSelectedRule={this.handleSelectedRule}
                                    onDeleteRule={this.handleDeleteRule}
                                    onAddRule={() => this.openRule({
                                                                    nombre: '',
                                                                    proceso: this.props.process,
                                                                    yo: '1',
                                                                    condicion: [],
                                                                    accion: [],
                                                                    tipo: undefined,
                                                                })}
                                    onEditRule={this.openRule}
                                />
                            }
                            {(rulesAvailable && edit_rule) && 
                                <EditRules
                                    {...this.props}
                                    rule={rule}
                                    tiporegla={tiporegla}
                                    options={options}
                                    transitions={manage_form.transitions}
                                    templates={templates}
                                    families={manage_process.families}
                                    onClose={this.handleCloseRule}
                                    onAddAction={this.handleAddActionTransition}
                                    onAddCondition={this.handleAddConditionTransition}
                                    onDeleteCondition={this.handleDeleteCondition}
                                    onDeleteAction={this.handleDeleteAction}
                                    onChange={this.handleChange}
                                />
                            }
                        </div>
                        <div className={'flex_60 overflow_y_scroll showbar padding_right_12'}>
                            <Fields
                                {...this.props}
                                form={form}
                                data={data}
                                edit_rule={edit_rule}
                                entities={entities}
                                rule={rule}
                                rules={rules}
                                typeId={type}
                                selectedType={selectedType}
                                selectedField={selectedField}
                                selectedRule={selectedRule}
                                onSelectedField={this.handleSelectedField}
                                onModification={this.handleModification}
                                onAddContion={this.handleAddCondition}
                                onAddAction={this.handleAddAction}
                            />
                        </div>
                        {error && (
                            <Snackbar
                                open={error}
                                variant={ errorType ? errorType : "error" }
                                text={error}
                                onClose={this.handleClose}
                            />
                        )}
                        {message && (
                            <Snackbar
                                open={!!message}
                                variant="info"
                                text={message}
                                onClose={this.handleClose}
                            />
                        )}
                        {confirm_save &&
                            <Alert
                                title="alert_dialog_corfirm_title"
                                text="alert_dialog_confirm_message"
                                open={true}
                                onCancel={this.handleCancel}
                                onConfirm={this.handleSummit}
                            />
                        }
                    </div>
                </div>
            );
        }
    }
}

Main.propTypes = {
    intl: intlShape.isRequired,
    manage_form: PropTypes.object.isRequired,
    manage_form_is_loading: PropTypes.bool.isRequired,
    manage_form_has_error: PropTypes.object.isRequired,
    manage_form_is_saving: PropTypes.bool.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actionsprocess, actionsform, home, security), dispatch);
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
        session: state.session,
        manage_process: state.manage_process,
        manage_process_is_loading: state.manage_process_is_loading,
        manage_process_has_error: state.manage_process_has_error,
        manage_form: state.manage_form,
        manage_form_is_loading: state.manage_form_is_loading,
        manage_form_has_error: state.manage_form_has_error,
        manage_form_is_saving: state.manage_form_is_saving,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Main)));



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Main.js